import VGridformDialog from '../components/v-gridform-dialog'
import Vue from 'vue'
import vuetify from '../../vuetify'

// Vue.component(VGridformDialog.name, VGridformDialog)

/*
import Vuex from 'vuex'
import {CONST} from '@src/plugins/vue-gridform/shared/constants'
import VGridformModule from '@src/plugins/vue-gridform/state/store'

const store = new Vuex.Store({
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production'
})
store.registerModule(CONST.NAMESPACE, VGridformModule)
Vue.use(Vuex)
*/

export default function dialog(options) {
    return new Promise((resolve) => {
        const _dialog = document.createElement('div')
        const VgfDialog = Vue.extend(VGridformDialog)
        const vm = new VgfDialog({
            el: _dialog,
            propsData: { options },
            vuetify,
            onMounted() {
                // console.log('onMounted')
            },
            onClose() {
                // console.log('onClose')
            }
        })

        vm.$on('submit', (args) => {
            resolve(!args ? true : args)
        })
        vm.$on('cancel', () => {
            resolve(false)
        })
    })
}
